///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

export enum DuplicateTypeEnum {
    NEW,
    NOT_IMPORT,
    UPDATE_ORIGIN,
    POTENTIAL_DUPLICATE
}
